import _ from 'lodash';
import React, { Component, useState, useEffect } from 'react';
// import { AnchorButton, Callout, Classes, Divider } from '@blueprintjs/core';
import { Callout, Classes, Divider } from '@blueprintjs/core';
// import { Tooltip2 as Tooltip } from '@blueprintjs/popover2';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';
import c from 'classnames';

import withRouter from 'app/withRouter';
import { DialogToggleButton } from 'components/Toolbar';
import DocumentUploadDialog from 'dialogs/DocumentUploadDialog/DocumentUploadDialog';
import DocumentFileDialog from 'dialogs/DocumentFileDialog/DocumentFileDialog';
// import DocumentFolderDialog from 'dialogs/DocumentFolderDialog/DocumentFolderDialog';
import EntityActionBar from 'components/Entity/EntityActionBar';
// import EntityDeleteButton from 'components/Toolbar/EntityDeleteButton';
// import EntitySearch from 'components/EntitySearch/EntitySearch';
// import { ErrorSection } from 'components/common';
// import { getGroupField } from 'components/SearchField/util';
import getEntityLink from 'util/getEntityLink';
// import { selectEntitiesResult, selectModel } from 'selectors';
import { selectEntitiesResult } from 'selectors';
import { deleteEntity, queryEntities } from 'actions';
import { Icon, Button } from '@blueprintjs/core';
import './DocumentManager.scss';
import axios from 'axios';

const messages = defineMessages({
  empty: {
    id: 'entity.document.manager.empty',
    defaultMessage: 'No files or directories.',
  },
  emptyCanUpload: {
    id: 'entity.document.manager.emptyCanUpload',
    defaultMessage:
      'No files or directories. Drop files here or click to upload.',
  },
  search_placeholder: {
    id: 'entity.document.manager.search_placeholder',
    defaultMessage: 'Search documents',
  },
  search_placeholder_document: {
    id: 'entity.document.manager.search_placeholder_document',
    defaultMessage: 'Search in {label}',
  },
  cannot_map: {
    id: 'entity.document.manager.cannot_map',
    defaultMessage: 'Select a table document to generate structured entities',
  },
  new: {
    id: 'document.folder.new',
    defaultMessage: 'New folder',
  },
  upload: {
    id: 'document.upload.button',
    defaultMessage: 'Upload',
  },
});

const Thumbnail = ({ contentHash }) => {
  const [imageSrc, setImageSrc] = useState(null); // State for storing the image URL
  const [isLoading, setIsLoading] = useState(true); // State for loading status
  const [error, setError] = useState(null); // State for error handling

  // Function to fetch image data
  const fetchImageData = async (hash) => {
    try {
      const response = await axios.get(`/api/2/documents/preview/${hash}`);
      // Convert the response blob into a URL
      const imageUrl = `data:image/png;base64,${response.data}`;
      setImageSrc(imageUrl);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error fetching image data:', err);
      setError(err.message || 'Failed to load image');
    } finally {
      setIsLoading(false);
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
  };

  // Fetch the image when the component mounts
  useEffect(() => {
    if (contentHash) {
      fetchImageData(contentHash);
    }
  }, [contentHash]);

  // Render the component
  if (isLoading) {
    return <div>Loading image...</div>;
  }

  if (error) {
    return <div>Error loading image: {error}</div>;
  }

  return (
    <img
      src={imageSrc}
      alt="Thumbnail"
      className="thumbnail"
      onError={() => setError('Failed to display image')}
    />
  );
};

export class DocumentManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selection: [],
      isListViewVisible: true,
      isMediaModalOpen: false,
      currentMedia: { contentHash: '', fileName: '', type: '' },
    };
    this.updateSelection = this.updateSelection.bind(this);
    this.openMappingEditor = this.openMappingEditor.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
  }

  updateSelection(document) {
    const { selection } = this.state;
    this.setState({
      selection: _.xorBy(selection, [document], 'id'),
    });
  }

  canUpload() {
    const { collection, document } = this.props;
    const parentFolder =
      document == null ? true : document.schema.isA('Folder');

    if (!parentFolder || !collection.writeable) {
      return false;
    }
    return true;
  }

  updateQuery(newQuery) {
    const { navigate, location } = this.props;
    navigate({
      pathname: location.pathname,
      search: newQuery.toLocation(),
      hash: location.hash,
    });
  }

  onSearchSubmit(queryText) {
    const { query } = this.props;
    const newQuery = query.set('q', queryText);
    this.updateQuery(newQuery);
  }

  openMappingEditor() {
    const { navigate } = this.props;
    const { selection } = this.state;
    const pathname = getEntityLink(selection[0]);
    navigate({ pathname, hash: queryString.stringify({ mode: 'mapping' }) });
  }

  toggleListView = (isVisible) => {
    this.setState({ isListViewVisible: isVisible });
  };

  async componentDidMount() {
    // Fetch data when the component mounts
    await this.fetchExternalData(this.props.params.collectionId);
  }

  async fetchExternalData(collectionId) {
    if (!collectionId) {
      return;
    }
    this.setState({ loading: true });
    try {
      const response = await axios.get(`/api/2/documents/list/${collectionId}`); // Replace with your actual endpoint
      this.setState({ externalData: response.data, loading: false });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching external data:', error);
      this.setState({ error, loading: false });
    }
  }

  render() {

    const { externalData, error, loading } = this.state;
    const getFileType = (fileName) => {
      const extension = fileName.split('.').pop().toLowerCase();
    
      // Map of file extensions to types
      const extensionMap = {
        png: 'PNG File',
        jpg: 'JPG File',
        jpeg: 'JPG File',
        txt: 'Text Document',
        doc: 'Microsoft Word Document',
        docx: 'Microsoft Word Document',
        xls: 'Microsoft Excel Worksheet',
        xlsx: 'Microsoft Excel Worksheet',
        pdf: 'PDF Document',
        zip: 'WinRAR ZIP Archive',
        sql: 'SQL file',
        html: 'HTML Document',
        htm: 'HTML Document',
        eml: 'Email File',
        mp4: 'MP4 Video File',
        mp3: 'MP3 Audio File',
        mov: 'QuickTime Movie',
      };
    
      // Return the type based on the extension
      return extensionMap[extension] || 'Unknown Type';
    };
    const fetchDownloadFile = async (contentHash, fileName) => {
      // Implement the file download logic here
      if (window.confirm("Are you sure you want to download this file?")) {
        try {
          const response = await axios.get(`/api/2/documents/download/${contentHash}`, {
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = window.document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); // You can set the file name here
          window.document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error downloading file:', error);
        }
      }
    };

    const deleteFile = async (contentHash) => {
      if (window.confirm("Are you sure you want to delete this file?")) {
        try {
          await axios.get(`/api/2/documents/delete/${contentHash}`);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error downloading file:', error);
        }
        await this.fetchExternalData(this.props.params.collectionId);
      }
    };

    const refreshListView = async () => {
      await this.fetchExternalData(this.props.params.collectionId);
    };

    const openFileForEdit = async (contentHash, fileName) => {
      const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
      const audioExtensions = ['mp3', 'wav', 'ogg'];
      const imageExtensions = ['png', 'jpg', 'jpeg', 'gif'];
      const officeExtensions = [
        'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'epub', 'fb2', 'fodt', 'htm', 'html', 'mht', 'mhtml', 'odt', 'ott', 'rtf', 'stw', 'sxw', 'txt', 'wps', 'wpt', 'xml',
        'csv', 'et', 'ett', 'fods', 'ods', 'ots', 'sxc', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xml',
        'dps', 'dpt', 'fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx', 'sxi',
        'djvu', 'docxf', 'oform', 'oxps', 'pdf', 'xps'
      ];

      const extension = fileName.split('.').pop().toLowerCase();

      if (videoExtensions.includes(extension)) {
        // Trigger video playback modal
        this.setState({ isMediaModalOpen: true, currentMedia: { contentHash, fileName , type: 'video' }  });
      } else if (audioExtensions.includes(extension)) {
        // Trigger audio playback modal
        this.setState({
          isMediaModalOpen: true,
          currentMedia: { contentHash, fileName, type: 'audio' },
        });
      } else if (imageExtensions.includes(extension)) {
        // Trigger image display modal
        this.setState({
          isMediaModalOpen: true,
          currentMedia: { contentHash, fileName, type: 'image' },
        });
      } else if (officeExtensions.includes(extension)) {
        window.open(`/onlyoffice/${contentHash}`, '_blank');
      } else {
        // alert(contentHash); // Keep existing functionality for non-video files
        await fetchDownloadFile(contentHash, fileName);
      }
    };

    const {
      collection,
      document,
      // fileSizeProp,
      query,
      // result,
      hasPending,
      intl,
      showSearch = true,
    } = this.props;
    const { selection, isListViewVisible } = this.state;
    const mutableDocument =
      document === undefined || document?.schema?.name === 'Folder';
    const showActions = collection?.writeable && mutableDocument;
    const canUpload = this.canUpload();
    // const canMap = selection.length === 1 && selection[0].schema.isA('Table');

    // const searchPlaceholder = !!document
    //   ? intl.formatMessage(messages.search_placeholder_document, {
    //       label: document.getCaption(),
    //     })
    //   : intl.formatMessage(messages.search_placeholder);

    // const emptyComponent = canUpload ? (
    //   <div className="DocumentManager__content__empty">
    //     <DialogToggleButton
    //       buttonProps={{
    //         minimal: true,
    //         fill: true,
    //       }}
    //       Dialog={DocumentUploadDialog}
    //       dialogProps={{ collection, parent: document }}
    //     >
    //       <ErrorSection
    //         icon="plus"
    //         title={intl.formatMessage(messages.emptyCanUpload)}
    //       />
    //     </DialogToggleButton>
    //   </div>
    // ) : (
    //   <ErrorSection
    //     icon="folder-open"
    //     title={intl.formatMessage(messages.empty)}
    //   />
    // );

    return (
      <div className="DocumentManager">
        {(showSearch || showActions) && (
          <EntityActionBar
            query={query}
            writeable={showActions}
            selection={selection}
            resetSelection={() => this.setState({ selection: [] })}
            // onSearchSubmit={this.onSearchSubmit}
            // searchPlaceholder={searchPlaceholder}
            // searchDisabled={result.total === 0 && !query.hasQuery()}
          >
            {canUpload && (
              <DialogToggleButton
                buttonProps={{
                  text: intl.formatMessage(messages.upload),
                  icon: 'upload',
                }}
                Dialog={DocumentUploadDialog}
                dialogProps={{ collection, parent: document, onUploadSuccess: refreshListView }}
              />
            )}
            <Divider />
            <DialogToggleButton
              buttonProps={{
                text: 'เอกสารใหม่',
                icon: 'plus',
              }}
              Dialog={DocumentFileDialog}
              dialogProps={{ collection, parent: document, onClose: async () => await refreshListView() }}
            />
            {/* <DialogToggleButton
              buttonProps={{
                text: intl.formatMessage(messages.new),
                icon: 'folder-new',
              }}
              Dialog={DocumentFolderDialog}
              dialogProps={{ collection, parent: document }}
            /> */}
            {/* <Tooltip
              content={canMap ? null : intl.formatMessage(messages.cannot_map)}
              className="prevent-flex-grow"
            >
              <AnchorButton
                icon="new-object"
                disabled={!canMap}
                onClick={this.openMappingEditor}
              >
                <FormattedMessage
                  id="document.mapping.start"
                  defaultMessage="Generate entities"
                />
              </AnchorButton>
            </Tooltip> */}
            {/* <EntityDeleteButton
              entities={selection}
              onSuccess={() => this.setState({ selection: [] })}
              actionType="delete"
              deleteEntity={this.props.deleteEntity}
              showCount
            /> */}
          </EntityActionBar>
        )}
        {hasPending && (
          <Callout
            className={c(`${Classes.ICON}-info-sign`, Classes.INTENT_WARNING)}
          >
            <FormattedMessage
              id="refresh.callout_message"
              defaultMessage="Documents are being processed. Please wait..."
            />
          </Callout>
        )}
        {(showSearch && showActions) && (
          <div style={{ display: 'inline-block', marginBottom: '10px' }}>
            <Button
              className="bp4-button"
              onClick={() => this.toggleListView(true)}
            >
              <Icon icon="list" className="left-icon" />
              <span className="bp4-button-text">List</span>
            </Button>
            &nbsp;&nbsp;
            <Button
              className="bp4-button"
              onClick={() => this.toggleListView(false)}
            >
              <Icon icon="eye-open" className="left-icon" />
              <span className="bp4-button-text">Preview</span>
            </Button>
            &nbsp;&nbsp;
            <Button
              className="bp4-button"
              onClick={() => refreshListView()}
            >
              <Icon icon="refresh" className="left-icon" />
              <span className="bp4-button-text">Refresh</span>
            </Button>
          </div>
        )}
        <div className="DocumentManager__content">
          {this.state.isMediaModalOpen && (
            <div className="media-modal">
              <div className="media-modal-content">
                {this.state.currentMedia.type === 'video' && (
                  <video
                    src={`/api/2/documents/download/${this.state.currentMedia.contentHash}`}
                    controls
                    width="800"
                    height="450"
                  >
                    Your browser does not support the video tag.
                  </video>
                )}
                {this.state.currentMedia.type === 'audio' && (
                  <audio
                    src={`/api/2/documents/download/${this.state.currentMedia.contentHash}`}
                    controls
                  >
                    Your browser does not support the audio tag.
                  </audio>
                )}
                {this.state.currentMedia.type === 'image' && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '450px', // Set container height for consistent display
                      overflow: 'hidden', // Prevent overflow if the image is larger
                    }}
                  >
                    <img
                      src={`/api/2/documents/download/${this.state.currentMedia.contentHash}`}
                      alt={this.state.currentMedia.fileName}
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  </div>
                )}
                <Button
                  icon="cross"
                  onClick={() => this.setState({ isMediaModalOpen: false })}
                >
                  Close
                </Button>
              </div>
            </div>
          )}

          {loading && <div>Loading data...</div>}
          {error && <div>Error fetching data: {error.message}</div>}
          {externalData && (
            <div className="EntitySearchResults-outer-container">
              {isListViewVisible && (
                <div className="EntitySearchResults-inner-container"> 
                  <table className="EntitySearchResults data-table">
                    <thead>
                      <tr>
                        <th className="select"></th>
                        <th className="SortableTH clickable wide"><div>ชื่อ<span className="caret bp4-icon-large"></span></div></th>
                        <th className="SortableTH clickable wide"><div>วันที่<span className="caret bp4-icon-large"></span></div></th>
                        <th className="SortableTH clickable wide"><div>Type<span className="caret bp4-icon-large"></span></div></th>
                        <th className="SortableTH clickable wide"><div>Size<span className="caret bp4-icon-large"></span></div></th>
                      </tr>
                    </thead>
                    <tbody>
                      {externalData.map((data, index) => (
                        <tr key={index} className="EntitySearchResultsRow">
                          <td className="select">
                            {/* <label className="bp4-control bp4-checkbox"><input type="checkbox" /><span className="bp4-control-indicator"></span></label> */}
                            <span aria-hidden="true" icon="download" className="bp4-icon bp4-icon-download" style={{ cursor: 'pointer' }} onClick={() => fetchDownloadFile(data.content_hash, data.file_name)}>
                              <svg data-icon="download" width="16" height="16" viewBox="0 0 16 16" role="img">
                                <path d="M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM11.7 9.7l-3 3c-.18.18-.43.29-.71.29s-.53-.11-.71-.29l-3-3A1.003 1.003 0 015.7 8.28l1.29 1.29V3.99c0-.55.45-1 1-1s1 .45 1 1v5.59l1.29-1.29a1.003 1.003 0 011.71.71c0 .27-.11.52-.29.7z" fillRule="evenodd"></path>
                              </svg>
                            </span>
                            &nbsp;&nbsp;
                            <span aria-hidden="true" icon="trash" className="bp4-icon bp4-icon-trash" style={{ cursor: 'pointer' }} onClick={() => deleteFile(data.content_hash)}>
                              <svg data-icon="trash" width="16" height="16" viewBox="0 0 16 16" role="img">
                                <path d="M14.49 3.99h-13c-.28 0-.5.22-.5.5s.22.5.5.5h.5v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-8.5 9c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm3 0c0 .55-.45 1-1 1s-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6zm2-12h-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-4c-.55 0-1 .45-1 1v1h14v-1c0-.55-.45-1-1-1z" fillRule="evenodd"></path>
                              </svg>
                            </span>
                          </td>
                          <td className="caption">
                            <span className="EntityLink" style={{ cursor: 'pointer' }} onClick={() => openFileForEdit(data.content_hash, data.file_name)}>
                              <span className="EntityLabel">
                                <span className="SchemaIcon bp4-icon left-icon">
                                  <svg viewBox="0 0 25 25" height="16" width="16">
                                    <path d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 1 1 0 1h-8a.5.5 0 0 1-.5-.5z"></path>
                                    <path d="M6 6.5a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.5-.5z"></path>
                                    <path d="M6 9.5a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.5-.5z"></path>
                                    <path d="M4 1v22h16V4.414L16.586 1H4zm0-1h12.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V23a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"></path>
                                    <path d="M20 4l1 1h-4a1 1 0 0 1-1-1V0l1 1v3h3zm0 0l1 1h-4a1 1 0 0 1-1-1V0l1 1v3h3z"></path><path d="M6 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.5-.5z"></path>
                                    <path d="M12 18.5a1.5 1.5 0 0 0-1-1.415v2.83a1.5 1.5 0 0 0 1-1.415zM10.5 16a2.5 2.5 0 1 1 0 5 .5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5z"></path>
                                    <path d="M7 18h1v-1H7v1zm0 1v1.5a.5.5 0 1 1-1 0V17a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7z"></path>
                                    <path d="M15 17v3.5a.5.5 0 1 1-1 0V17a1 1 0 0 1 1-1h1.5a.5.5 0 1 1 0 1H15z"></path><path d="M16.5 18.5a.5.5 0 0 1-.5.5h-2v-1h2a.5.5 0 0 1 .5.5z"></path>
                                  </svg>
                                </span>
                                <span>{data.file_name}</span>
                              </span>
                            </span>
                          </td>
                          <td className="dates">{data.created_at.split('T')[0]}</td>
                          <td className="dates">{getFileType(data.file_name)}</td>
                          <td className="fileSize">{data.file_size}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {!isListViewVisible && (
                <>
                  <div className="EntitySearchResults-preview">
                    {externalData.map((data, index) => (
                      <div key={index} className="EntitySearchResults-preview-card" onClick={() => openFileForEdit(data.content_hash, data.file_name)}>
                        <Thumbnail contentHash={data.content_hash} />
                        <label>{data.file_name}</label>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
          {/* <EntitySearch
            query={query}
            showPreview={false}
            selection={selection}
            writeable={showActions}
            updateSelection={this.updateSelection}
            emptyComponent={emptyComponent}
            columns={[getGroupField('dates'), fileSizeProp]}
          /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { collection } = ownProps;
  // const model = selectModel(state);
  // const fileSizeProp = model.getSchema('Document').getProperty('fileSize');

  let { query } = ownProps;
  query = query.defaultSortBy('caption', 'asc');
  if (collection.writeable) {
    query = query.set('cache', 'false');
  }
  const result = selectEntitiesResult(state, query);

  return {
    query,
    result,
    // fileSizeProp: {
    //   name: 'fileSize',
    //   label: fileSizeProp.label,
    //   type: fileSizeProp.type.name,
    //   isProperty: true,
    // },
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { queryEntities, deleteEntity }),
  injectIntl
)(DocumentManager);
